import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { EditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';

import { SpEditorComponent } from './sp-editor.component';
import { SpPipesModule } from '@common/pipes/pipes.module';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TranslateModule } from '@ngx-translate/core';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { LayoutFacade } from '@web/store/layout/layout.facade';

@NgModule({
    imports: [
        CommonModule,
        EditorModule,
        FormsModule,
        SpPipesModule,
        BsDropdownModule.forRoot(),
        ReactiveFormsModule,
        TooltipModule,
        TranslateModule,
        SpEditorComponent,
    ],
    providers: [{ provide: TINYMCE_SCRIPT_SRC, useValue: './tinymce/tinymce.min.js' }, LayoutFacade],
    exports: [SpEditorComponent],
})
export class SpEditorModule {}
